const full = {
    left : [
        {'id': 'blog', 'href': 'https://www.bohemia.net/blog', 'name': 'Blog'},
        {'id': 'games', 'href': 'https://www.bohemia.net/games', 'name': 'Games'},
        {'id': 'incubator', 'href': 'https://incubator.bistudio.com', 'name': 'Incubator'},
        {
            'id'      : 'company',
            'name'    : 'Company',
            'dropdown': [
                {'href': 'https://www.bohemia.net/company/about', 'name': 'About us'},
                {'href': 'https://www.bohemia.net/company/brochure', 'name': 'Brochure'},
                {'href': 'https://www.bohemia.net/company/contacts', 'name': 'Contacts'},
                'separator',
                {'href': 'https://enfusionengine.com/', 'name': 'Enfusion Engine'},
                {'href': 'https://pro.bohemia.net/services/motion-capture', 'name': 'Motion Capture'},
                {'href': 'https://pro.bohemia.net/services/photogrammetry-rig', 'name': 'Photogrammetry'},
                {'href': 'https://pro.bohemia.net/services/audio-recording-studio', 'name': 'Audio recording'},
            ]
        },
        {
            'id'      : 'careers',
            'name'    : 'Careers',
            'dropdown': [
                {'href': 'https://careers.bohemia.net', 'name': 'Start'},
                {'href': 'https://careers.bohemia.net/positions', 'name': 'Job openings'},
                {'href': 'https://careers.bohemia.net/open-application', 'name': 'Open application'},
                {'href': 'https://careers.bohemia.net/internships', 'name': 'Internships'},
                {'href': 'https://careers.bohemia.net/expats', 'name': 'Expats'},
            ]
        },
        {
            'id'      : 'community',
            'name'    : 'Community',
            'dropdown': [
                {'href': 'https://forums.bistudio.com', 'name': 'Forums'},
                {'href': 'https://community.bistudio.com', 'name': 'Wiki'},
                {'href': 'https://www.bohemia.net/community/licenses', 'name': 'Licences'},
                {
                    'href': 'https://www.bohemia.net/community/game-content-usage-rules',
                    'name': 'Game Content Usage',
                },
                {'href': 'https://www.bohemia.net/monetization', 'name': 'Server Monetization'},
            ]
        },
        {'id': 'store', 'href': 'https://store.bistudio.com', 'name': 'Store'},
    ],
    right: []
};

const compact = {
    left : [
        {'href': 'https://www.bohemia.net/games', 'name': 'Games'},
        {'href': 'https://incubator.bistudio.com', 'name': 'Incubator'},
        {'href': 'https://store.bistudio.com', 'name': 'Store'},
    ],
    right: []
};

const account = [
    {'href': 'https://accounts.bistudio.com', 'name': 'Account Settings'},
    {'href': 'https://store.bistudio.com/account', 'name': 'Purchases'}
];

export default {
    full   : full,
    compact: compact,
    account: account
};